const menuEventCodes = {
  MENU_LIST_CHANGED: 'MENU_LIST_CHANGED'
};

export default menuEventCodes;
